
import emitter from "../event/eventBus";
import { computed, defineComponent, PropType, ref, watchEffect } from 'vue'
import Button from "./Button.vue";
export default defineComponent({
    components:{
        Button
    },
    props:{
        topStyle:String as PropType<string>
    },
    emits:["on-to-top"],
    setup(props,{ emit }){
        const fillColor = ref("#fff");
        const onMouseEnterHandler = () => {
            fillColor.value = "#2396ef";
        }
        const onMouseLeaveHandler = () => {
            fillColor.value = "#fff";
        }
        emitter.$on("on-click",(callback:Function) => {
            const clickType:string = callback();
            if(clickType === "topBtn"){
                emit("on-to-top");
            }
        })
        const topDisplay = computed(() => props.topStyle);
        return {
            fillColor,
            topDisplay,
            onMouseEnterHandler,
            onMouseLeaveHandler
        }
    }
})

